import { Callout } from "@wayflyer/flyui";
import { useIntl } from "react-intl";

import { MESSAGES } from "../connection-manager-next/message-definitions";

import type { OnlineSalesBannerState } from "./online-sales-banner-state";

const MESSAGE_FOR_KEY = {
  blockedSingle: MESSAGES.onlineSalesBannerBlockedSingle,
  sameConnectorCovered: MESSAGES.onlineSalesBannerSameConnectorCovered,
  otherConnectorCovered: MESSAGES.onlineSalesBannerOtherConnectorCovered,
  multiplePlatforms: MESSAGES.onlineSalesBannerMultiplePlatforms,
} as const;

export const OnlineSalesStatusBanner = ({ state }: { state: NonNullable<OnlineSalesBannerState> }) => {
  const intl = useIntl();

  return (
    <Callout
      variant={state.variant}
      description={intl.formatMessage(
        MESSAGE_FOR_KEY[state.messageKey],
        "platformName" in state ? { platformName: state.platformName } : undefined
      )}
    />
  );
};
